<template>
    <p>Please wait...</p>
</template>

<script>
    import router from '@/router';
    import Oidc from 'oidc-client';

    export default {
        mounted() {
            var mgr = new Oidc.UserManager({ userStore: new Oidc.WebStorageStateStore() });
            var self = this;

            mgr.signinRedirectCallback().then(function (user) {
                var url = user.state || '/';
                router.push(url);
            }).catch(function () {
                self.$appError(`We're sorry, an error has occurred during authentication.`);
            });
        }
    };
</script>